var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { Flex, Box } from "theme-ui";
import React from "react";
import { Button, Icon, VisuallyHidden, LUMOS_ONLY_SELECT, Card, ButtonLink, Menu } from "@loanpal/lumos__core";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import { jsxs, jsx, Fragment } from "theme-ui/jsx-runtime";
const pageOptions = [{
  name: "10",
  value: "10"
}, {
  name: "20",
  value: "20"
}, {
  name: "30",
  value: "30"
}, {
  name: "40",
  value: "40"
}, {
  name: "50",
  value: "50"
}];
const Pagination = ({
  canPreviousPage,
  previousPage,
  canNextPage,
  pageCount,
  pageIndex,
  pageSize,
  nextPage,
  setPageSize,
  slimMode = false
}) => {
  const desktopOnly = slimMode ? {
    display: "none"
  } : {
    display: ["none", "block"]
  };
  const mobileOnly = slimMode ? {
    display: "block"
  } : {
    display: ["block", "none"]
  };
  const buttonPadding = slimMode ? 0 : [0, 3];
  const selectedPage = pageOptions.find((x) => pageSize.toString() === x.value);
  return jsxs(Flex, {
    sx: {
      alignItems: "center",
      mt: 1
    },
    children: [jsxs(Button, {
      variant: "ghost",
      onClick: previousPage,
      disabled: !canPreviousPage,
      sx: {
        pl: 0,
        pr: buttonPadding,
        mr: 1
      },
      children: [jsx(Icon, {
        variant: "angle-left",
        size: "sm",
        sx: {
          transform: "translateY(-1px)"
        }
      }), jsxs(Box, {
        sx: desktopOnly,
        children: ["Previous", jsx(VisuallyHidden, {
          children: "Page"
        })]
      }), jsx(VisuallyHidden, {
        sx: mobileOnly,
        children: "Previous Page"
      })]
    }), jsxs(Box, {
      variant: "inputContainer.description",
      sx: __spreadProps(__spreadValues({}, desktopOnly), {
        mx: 2
      }),
      children: ["Page ", pageIndex + 1, " of ", pageCount]
    }), jsxs(Button, {
      variant: "ghost",
      onClick: nextPage,
      disabled: !canNextPage,
      sx: {
        pl: buttonPadding,
        pr: 0,
        ml: 1
      },
      children: [jsxs(Box, {
        sx: desktopOnly,
        children: ["Next", jsx(VisuallyHidden, {
          children: "Page"
        })]
      }), jsx(VisuallyHidden, {
        sx: mobileOnly,
        children: "Next Page"
      }), jsx(Icon, {
        variant: "angle-right",
        size: "sm",
        sx: {
          transform: "translateY(-1px)"
        }
      })]
    }), !slimMode && jsx(LUMOS_ONLY_SELECT, {
      sx: {
        mt: -1,
        ml: "auto"
      },
      label: "Number of items per page",
      selectedValueItem: selectedPage,
      name: "paging",
      onChange: (item) => {
        item ? setPageSize(Number.parseInt(item.value, 10)) : setPageSize(20);
      },
      items: pageOptions
    })]
  });
};
const TableHeader = ({
  column,
  compact,
  cardTable
}) => {
  const rotationDeg = column.isSortedDesc ? "rotate(0deg)" : "rotate(180deg)";
  const iconType = column.isSorted ? "sort-selected" : "sort";
  const sortProps = column.getSortByToggleProps();
  const headerProps = column.getHeaderProps(sortProps);
  const transformation = column.isSorted ? `translateY(5px) ${rotationDeg}` : "translateY(5px)";
  return jsxs(Box, __spreadProps(__spreadValues({
    as: "th",
    variant: !cardTable ? "" : "text.small",
    sx: {
      textAlign: column.textAlign,
      fontWeight: 600,
      py: compact ? 1 : cardTable ? 3 : 2,
      px: compact ? 1 : cardTable ? 3 : 2,
      whiteSpace: "nowrap",
      mb: !cardTable ? "" : -3,
      borderBottom: !cardTable ? "1px solid" : "",
      borderTop: !cardTable ? "" : "1px solid",
      borderColor: !cardTable ? "neutral.l1" : "neutral.l3"
    }
  }, headerProps), {
    children: [column.render("Header"), column.canSort && jsx(Icon, {
      variant: iconType,
      size: "sm",
      sx: {
        ml: "1px",
        transform: transformation,
        color: column.isSorted ? "neutral.base" : "neutral.l2",
        mt: -5
      }
    })]
  }));
};
const TableCell = ({
  compact,
  cell
}) => jsx(Box, __spreadProps(__spreadValues({
  as: "td",
  p: compact ? 1 : 2
}, cell.getCellProps()), {
  sx: {
    borderBottom: "1px solid",
    borderColor: "neutral.l3",
    textAlign: cell.column.textAlign,
    whiteSpace: "nowrap"
  },
  children: cell.render("Cell")
}));
const IndeterminateCheckbox$1 = React.forwardRef((_a, ref) => {
  var _b = _a, {
    indeterminate
  } = _b, rest = __objRest(_b, [
    "indeterminate"
  ]);
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;
  React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return jsx("input", __spreadValues({
    type: "checkbox",
    ref: resolvedRef
  }, rest));
});
const Header$1 = ({
  getToggleAllRowsSelectedProps
}) => jsx("div", {
  children: jsx(IndeterminateCheckbox$1, __spreadValues({}, getToggleAllRowsSelectedProps()))
});
const Cell$1 = ({
  row
}) => jsx("div", {
  children: jsx(IndeterminateCheckbox$1, __spreadValues({}, row.getToggleRowSelectedProps()))
});
const Table$1 = ({
  actions = [],
  columns,
  compact = false,
  data,
  defaultSorted = [],
  manualPagination,
  manualSortBy = false,
  onSortChanged,
  paging = false,
  sx
}) => {
  const tableStateUpdateRef = React.useRef({
    internalChange: false
  });
  const {
    canNextPage,
    canPreviousPage,
    getTableBodyProps,
    getTableProps,
    gotoPage,
    headerGroups,
    nextPage,
    page,
    pageCount,
    pageOptions: pageOptions2,
    prepareRow,
    previousPage,
    rows,
    selectedFlatRows,
    setPageSize,
    state: {
      pageIndex,
      pageSize,
      sortBy = []
    },
    toggleAllRowsSelected
  } = useTable(__spreadProps(__spreadValues({
    columns,
    data,
    autoResetSortBy: !onSortChanged,
    initialState: __spreadValues({
      sortBy: defaultSorted,
      pageSize: 20
    }, manualPagination !== void 0 ? {
      pageIndex: manualPagination.pageIndex,
      pageSize: manualPagination.pageSize || 20
    } : {})
  }, manualPagination !== void 0 ? {
    manualPagination: true,
    pageCount: Math.ceil(manualPagination.pageCount)
  } : {}), {
    manualSortBy
  }), useSortBy, usePagination, useRowSelect, (hooks) => {
    if (!actions.length)
      return;
    hooks.visibleColumns.push((x) => [
      {
        id: "selection",
        Header: Header$1,
        Cell: Cell$1
      },
      ...x
    ]);
  });
  React.useEffect(() => {
    if (onSortChanged)
      onSortChanged(sortBy);
    if (sortBy !== defaultSorted && !manualSortBy)
      gotoPage(0);
    tableStateUpdateRef.current.internalChange = true;
  }, [sortBy]);
  React.useEffect(() => {
    if (manualPagination == null ? void 0 : manualPagination.onPageChanged)
      manualPagination.onPageChanged({
        pageIndex,
        pageSize
      });
    tableStateUpdateRef.current.internalChange = true;
  }, [pageIndex, pageSize]);
  React.useEffect(() => {
    if (!tableStateUpdateRef.current.internalChange) {
      gotoPage(0);
    }
  }, [data, gotoPage]);
  React.useEffect(() => {
    tableStateUpdateRef.current.internalChange = false;
  }, [data]);
  const paginationOptions = {
    canPreviousPage,
    canNextPage,
    page,
    pageCount,
    previousPage,
    nextPage,
    gotoPage,
    pageOptions: pageOptions2,
    setPageSize,
    pageIndex,
    pageSize
  };
  const rowListing = paging ? page : rows;
  const styles = Object.assign({}, {
    borderCollapse: "collapse",
    width: "100%",
    height: "100%"
  }, sx || {});
  return jsxs(Fragment, {
    children: [jsx(Box, {
      sx: {
        width: "100%",
        overflowX: "auto"
      },
      children: jsxs(Box, __spreadProps(__spreadValues({
        as: "table"
      }, getTableProps()), {
        sx: styles,
        children: [jsx(Box, {
          as: "thead",
          sx: {
            textAlign: ["center", "left"]
          },
          children: headerGroups.map((group) => jsx("tr", __spreadProps(__spreadValues({}, group.getHeaderGroupProps()), {
            children: group.headers.map((column, i) => jsx(TableHeader, {
              compact,
              column,
              cardTable: false
            }, i))
          })))
        }), jsx("tbody", __spreadProps(__spreadValues({}, getTableBodyProps()), {
          children: rowListing.map((row) => {
            prepareRow(row);
            return jsx(Box, __spreadProps(__spreadValues({
              as: "tr"
            }, row.getRowProps()), {
              sx: {
                "&:hover": {
                  bg: "primary.l4"
                }
              },
              children: row.cells.map((cell, cellIndex) => jsx(TableCell, {
                cell,
                compact
              }, cellIndex))
            }));
          })
        })), jsx(Box, {
          as: "tfoot",
          sx: {
            position: "sticky",
            bottom: 0,
            left: 0,
            right: 0,
            display: selectedFlatRows.length ? "table-footer-group" : "none",
            width: "100%"
          },
          children: jsx("tr", {
            children: jsx("td", {
              colSpan: columns.length + 1,
              children: jsxs(Card, {
                sx: {
                  bg: "primary.l4",
                  minHeight: 48,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  py: 1,
                  px: 3,
                  display: "flex",
                  alignItems: "center"
                },
                children: [selectedFlatRows.length, " selected |\xA0", jsx(ButtonLink, {
                  onClick: () => toggleAllRowsSelected(),
                  children: "Select all"
                }), jsxs(Box, {
                  sx: {
                    display: ["none", "none", "block"],
                    ml: 4
                  },
                  children: [actions.length >= 1 && jsx(Button, {
                    onClick: () => actions[0].onClick(selectedFlatRows),
                    variant: "secondary",
                    sx: {
                      mr: 2
                    },
                    children: actions[0].label
                  }), actions.length > 1 && jsxs(Menu, {
                    variant: "secondary",
                    listItems: actions.slice(1).map((x) => ({
                      onSelect: () => x.onClick(selectedFlatRows),
                      content: x.label
                    })),
                    children: ["More", " ", jsx(Icon, {
                      variant: "arrow-down",
                      "aria-hidden": true,
                      size: "sm",
                      sx: {
                        mr: "-8px",
                        my: "-3px"
                      }
                    })]
                  })]
                }), jsx(Box, {
                  sx: {
                    display: ["block", "block", "none"],
                    ml: 3
                  },
                  children: jsxs(Menu, {
                    variant: "secondary",
                    listItems: actions.map((x) => ({
                      onSelect: () => x.onClick(selectedFlatRows),
                      content: x.label
                    })),
                    children: ["More", " ", jsx(Icon, {
                      variant: "arrow-down",
                      "aria-hidden": true,
                      size: "sm",
                      sx: {
                        mr: "-8px"
                      }
                    })]
                  })
                }), jsx(Button, {
                  variant: "ghost",
                  onClick: () => toggleAllRowsSelected(false),
                  sx: {
                    ml: "auto"
                  },
                  children: jsx(Icon, {
                    variant: "times",
                    title: "Deselect all",
                    size: "sm"
                  })
                })]
              })
            })
          })
        })]
      }))
    }), paging && jsx(Pagination, __spreadValues({}, paginationOptions))]
  });
};
const IndeterminateCheckbox = React.forwardRef((_c, ref) => {
  var _d = _c, {
    indeterminate
  } = _d, rest = __objRest(_d, [
    "indeterminate"
  ]);
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;
  React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return jsx("input", __spreadValues({
    type: "checkbox",
    ref: resolvedRef
  }, rest));
});
const Header = ({
  getToggleAllRowsSelectedProps
}) => jsx("div", {
  children: jsx(IndeterminateCheckbox, __spreadValues({}, getToggleAllRowsSelectedProps()))
});
const Cell = ({
  row
}) => jsx("div", {
  children: jsx(IndeterminateCheckbox, __spreadValues({}, row.getToggleRowSelectedProps()))
});
const Table = ({
  data,
  columns,
  onRowClicked,
  defaultSorted = [],
  paging = false,
  sx,
  actions = [],
  onSortChanged,
  compact = false,
  manualSortBy = false,
  manualPagination,
  isPositionAbsolute = false,
  isOverflow = false
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    rows,
    prepareRow,
    selectedFlatRows,
    toggleAllRowsSelected,
    state: {
      pageIndex,
      pageSize,
      sortBy = []
    },
    canPreviousPage,
    canNextPage,
    pageCount,
    previousPage,
    nextPage,
    gotoPage,
    pageOptions: pageOptions2,
    setPageSize
  } = useTable(__spreadProps(__spreadValues({
    columns,
    data,
    autoResetSortBy: !onSortChanged,
    initialState: __spreadValues({
      sortBy: defaultSorted,
      pageSize: 20
    }, manualPagination !== void 0 ? {
      pageIndex: manualPagination.pageIndex,
      pageSize: manualPagination.pageSize || 20
    } : {})
  }, manualPagination !== void 0 ? {
    manualPagination: true,
    pageCount: Math.ceil(manualPagination.pageCount)
  } : {}), {
    manualSortBy
  }), useSortBy, usePagination, useRowSelect, (hooks) => {
    if (!actions.length)
      return;
    hooks.visibleColumns.push((x) => [
      {
        id: "selection",
        Header,
        Cell
      },
      ...x
    ]);
  });
  React.useEffect(() => {
    if (onSortChanged)
      onSortChanged(sortBy);
  }, [sortBy]);
  React.useEffect(() => {
    if (manualPagination == null ? void 0 : manualPagination.onPageChanged)
      manualPagination.onPageChanged({
        pageIndex,
        pageSize
      });
  }, [pageIndex, pageSize]);
  const paginationOptions = {
    canPreviousPage,
    canNextPage,
    page,
    pageCount,
    previousPage,
    nextPage,
    gotoPage,
    pageOptions: pageOptions2,
    setPageSize,
    pageIndex,
    pageSize
  };
  const rowListing = paging ? page : rows;
  const styles = Object.assign({}, {
    borderCollapse: "collapse",
    borderSpacing: 0,
    width: "100%",
    cellSpacing: 0,
    cellPadding: 0,
    height: "100%",
    marginRight: "4em"
  }, sx || {});
  return jsxs(Fragment, {
    children: [jsx(Box, {
      sx: {
        width: "100%",
        overflowX: isOverflow ? "auto" : "hidden"
      },
      children: jsxs(Box, __spreadProps(__spreadValues({
        as: "table"
      }, getTableProps()), {
        sx: styles,
        cellSpacing: 0,
        cellPadding: 0,
        children: [jsx(Box, {
          as: "thead",
          sx: {
            textAlign: ["center", "left"]
          },
          children: headerGroups.map((group) => jsx("tr", __spreadProps(__spreadValues({}, group.getHeaderGroupProps()), {
            children: group.headers.map((column, i) => jsx(TableHeader, {
              column,
              compact,
              cardTable: true
            }, i))
          })))
        }), jsx(Box, __spreadProps(__spreadValues({
          as: "tbody"
        }, getTableBodyProps()), {
          sx: {
            "tr:first-of-type > td": {
              pt: 0
            }
          },
          children: rowListing.map((row) => {
            prepareRow(row);
            return jsx(Box, __spreadProps(__spreadValues({
              as: "tr",
              onClick: () => onRowClicked == null ? void 0 : onRowClicked(row)
            }, row.getRowProps()), {
              sx: {
                "&:hover > td > div": {
                  bg: "primary.l4",
                  cursor: "pointer"
                },
                td: {
                  py: 1,
                  whiteSpace: "nowrap",
                  "& > div": {
                    bg: "white",
                    borderTop: "1px solid",
                    py: 3,
                    px: 3,
                    borderBottom: "1px solid",
                    borderColor: "neutral.l3"
                  },
                  "&:first-of-type > div": {
                    borderLeft: "1px solid",
                    borderColor: "neutral.l3",
                    borderTopLeftRadius: "rounded",
                    borderBottomLeftRadius: "rounded"
                  },
                  "&:nth-last-of-type(2)": {
                    position: isPositionAbsolute ? "absolute" : "static",
                    right: "5em",
                    width: "auto"
                  },
                  "&:last-of-type": {
                    position: isPositionAbsolute ? "absolute" : "static",
                    width: "auto",
                    right: 0,
                    " > div": {
                      borderRight: "1px solid",
                      borderColor: "neutral.l3",
                      borderTopRightRadius: "rounded",
                      borderBottomRightRadius: "rounded"
                    }
                  }
                }
              },
              children: row.cells.map((cell) => jsx(Box, __spreadProps(__spreadValues({
                as: "td"
              }, cell.getCellProps()), {
                children: jsx("div", {
                  children: cell.render("Cell")
                })
              })))
            }));
          })
        })), jsx(Box, {
          as: "tfoot",
          sx: {
            position: "sticky",
            bottom: 0,
            left: 0,
            right: 0,
            display: selectedFlatRows.length ? "table-footer-group" : "none",
            width: "100%"
          },
          children: jsx("tr", {
            children: jsx("td", {
              colSpan: columns.length + 1,
              children: jsxs(Card, {
                sx: {
                  bg: "primary.l4",
                  minHeight: 48,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  py: 1,
                  px: 3,
                  display: "flex",
                  alignItems: "center"
                },
                children: [selectedFlatRows.length, " selected |\xA0", jsx(ButtonLink, {
                  onClick: () => toggleAllRowsSelected(),
                  children: "Select all"
                }), jsxs(Box, {
                  sx: {
                    display: ["none", "none", "block"],
                    ml: 4
                  },
                  children: [actions.length >= 1 && jsx(Button, {
                    onClick: () => actions[0].onClick(selectedFlatRows),
                    variant: "secondary",
                    sx: {
                      mr: 2
                    },
                    children: actions[0].label
                  }), actions.length > 1 && jsxs(Menu, {
                    variant: "secondary",
                    listItems: actions.slice(1).map((x) => ({
                      onSelect: () => x.onClick(selectedFlatRows),
                      content: x.label
                    })),
                    children: ["More", " ", jsx(Icon, {
                      variant: "arrow-down",
                      "aria-hidden": true,
                      size: "sm",
                      sx: {
                        mr: "-8px",
                        my: "-3px"
                      }
                    })]
                  })]
                }), jsx(Box, {
                  sx: {
                    display: ["block", "block", "none"],
                    ml: 3
                  },
                  children: jsxs(Menu, {
                    variant: "secondary",
                    listItems: actions.map((x) => ({
                      onSelect: () => x.onClick(selectedFlatRows),
                      content: x.label
                    })),
                    children: ["More", " ", jsx(Icon, {
                      variant: "arrow-down",
                      "aria-hidden": true,
                      size: "sm",
                      sx: {
                        mr: "-8px"
                      }
                    })]
                  })
                }), jsx(Button, {
                  variant: "ghost",
                  onClick: () => toggleAllRowsSelected(false),
                  sx: {
                    ml: "auto"
                  },
                  children: jsx(Icon, {
                    variant: "times",
                    title: "Deselect all",
                    size: "sm"
                  })
                })]
              })
            })
          })
        })]
      }))
    }), paging && jsx(Pagination, __spreadValues({}, paginationOptions))]
  });
};
export { Table as CardTable, Table$1 as default };
